import React from 'react';
import { Navigate } from 'react-router-dom';
import { isWebAdmin } from '@/auth/webAccess';

const AdminRoute = ({ children }) => {
    const user = localStorage.getItem('user');
    let userData = null;

    try {
        userData = user ? JSON.parse(user) : null;
    } catch (error) {
        console.error("Error parsing user data for AdminRoute:", error);
    }

    if (!isWebAdmin(userData)) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default AdminRoute;
